module.exports = __webpack_public_path__ + "img/RX-Arcos-8.62fc10ab.png";